import { IObservable, Subject } from '~/rage/utils';
import { HudTaskType, IHudTaskProgress } from '~/shared';
import { IQuestsService } from './questsServiceTypes';

export class QuestsServiceStub implements IQuestsService {
	private readonly questsStub = new Subject<IHudTaskProgress>({
		type: HudTaskType.QUEST,
		text: 'Встретится с Артёмом Бахия!',
		currentCount: 0,
		targetCount: 1,
	});

	public getHudTask(): IObservable<IHudTaskProgress | null> {
		return this.questsStub;
	}
}
